// extracted by mini-css-extract-plugin
export default {"backdrop":"PromptBeforeNavigation_backdrop__ygRKD","container":"PromptBeforeNavigation_container__6FhvG","buttonContainer":"PromptBeforeNavigation_buttonContainer__yrqUu"};